import { Box } from '@mui/material';
import { Identifier } from '@okletsplay/core';
import { TOURNAMENT_ID_QUERY_KEY } from 'app/constants';
import { Route } from 'app/enums';
import { TournamentSettingsTitle } from '../../TournamentSettingsTitle';
import React, { FC } from 'react';
import { TextInput } from 'shared/components/Form/TextInput';
import { useStyles } from './TournamentSharedLink.styles';

interface TournamentSharedLinkProps {
  tournamentId: Identifier;
}

export const TournamentSharedLink: FC<TournamentSharedLinkProps> = ({ tournamentId }) => {
  const { classes } = useStyles();

  const shareLink = `${window.location.origin}${Route.Home}?${TOURNAMENT_ID_QUERY_KEY}=${tournamentId}`;

  if (!tournamentId) {
    return null;
  }

  return (
    <Box className={classes.root}>
      <TournamentSettingsTitle>Copy the link and share with friends!</TournamentSettingsTitle>
      <TextInput withCopy readOnly value={shareLink} />
    </Box>
  );
};
